import React, { useState } from "react";
import { Table, Container } from "react-bootstrap";
import Button from "../../../components/button/button.component";
import "./WebCommon.scss";
import { LeftArrow, LogoutIcon, RightArrow } from "../../../Assets/svgIcons";
import DatePicker from "react-datepicker";
import { Link } from "react-router-dom";
import moment from "moment";
import { formatCommaNumbers } from "../../../Utils/common.utils";

const FeeReport = ({ feereportData }) => {

  return (
    <section className="page_design">
      <Container>
        {/* <div className="backbtn mb-3">
          <Link to="/account"><span><LeftArrow /></span> Back</Link>
        </div> */}
        <div className="page_design_in">
          <div className="page_design_head">
            <h2>Fee Report</h2>
            {/* <div className="page_design_head_right">
              <div className="page_design_head_right_box">
                <div className="date_picker_design">
                  <label htmlFor="">From Date</label>
                  <DatePicker
                    selected={startDate}
                    onChange={(date) => setStartDate(date)}
                  />
                </div>
              </div>
              <div className="page_design_head_right_box">
                <div className="date_picker_design">
                  <label htmlFor="">To Date</label>
                  <DatePicker
                    selected={startDate}
                    onChange={(date) => setStartDate(date)}
                  />
                </div>
              </div>
              <div className="page_design_head_right_box">
                <button className='btn-style'>
                  <span><LogoutIcon /></span> Export
                </button>
              </div>
            </div> */}
          </div>
          <div className="page_design_body">
            <Table responsive>
              <thead>
                <tr>
                  <th></th>
                  <th>Sr No.</th>
                  <th>Fee Type</th>
                  <th>Balance</th>
                  <th>Amount</th>
                  <th>Fees Amount</th>
                  <th>Fees Percentage</th>
                  {/* <th>Fee Deducted</th> */}
                  <th>Date</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {feereportData?.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td></td>
                      <td>{index + 1}</td>
                      <td>{item.type}</td>
                      <td>${formatCommaNumbers(item.balance)}</td>
                      <td>${formatCommaNumbers(item.amount)}</td>
                      <td>${formatCommaNumbers(item.fee_amount)}</td>
                      <td>{formatCommaNumbers(item.fee_in_percent)}</td>
                      {/* <td>{item.feeducuted}</td> */}
                      <td>{moment(item.created_at).format('DD-MM-YYYY')}</td>
                      <td></td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default FeeReport;
